const ORDER_PRODUCTS_DOMAIN = 'orderProducts'
const ORDER_PRODUCTS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

export {
  ORDER_PRODUCTS_DOMAIN,
  ORDER_PRODUCTS_STATE
}
